import {
  LOAD_VIBE_LIMITATIONS,
  LOAD_VIBE_LIMITATIONS_FAIL,
  LOAD_VIBE_LIMITATIONS_SUCCESS,
  LoadVibeLimitations,
  LoadVibeLimitationsFail,
  LoadVibeLimitationsSuccess,
  VibeLimitationsAction
} from '../actions/vibe-limitations.action';

export interface IVibeLimitationsState {
  loading: boolean;
  loaded: boolean;
  data: any;
  error: any;
}

export const initialVibeLimitationsState: IVibeLimitationsState = {
  loading: false,
  loaded: false,
  data: null,
  error: null
};

export function vibeLimitationsReducer(state = initialVibeLimitationsState, action: VibeLimitationsAction): IVibeLimitationsState {
  let payload: any;

  switch (action.type) {
    case LOAD_VIBE_LIMITATIONS:
      payload = (<LoadVibeLimitations>action).payload;

      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };

    case LOAD_VIBE_LIMITATIONS_SUCCESS:
      payload = (<LoadVibeLimitationsSuccess>action).payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
        error: null
      };

    case LOAD_VIBE_LIMITATIONS_FAIL:
      payload = (<LoadVibeLimitationsFail>action).payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        error: payload
      };

    default:
      return state;
  }
}
